import { Directive, ElementRef, HostListener } from '@angular/core';
import { NavController } from '@ionic/angular';

@Directive({
  selector: '[appRouteTransformer]'
})
export class RouteTransformerDirective {

  constructor(private el: ElementRef, private navCtrl: NavController) { }

  @HostListener('click', ['$event'])
  public onClick(event) {
    if (event.target.tagName === 'A') {
      this.navCtrl.navigateForward([event.target.getAttribute('href')]);
      event.preventDefault();
    } else {
      return;
    }
  }

}
